import React, { Component } from "react";
import AppContext from "../../appContext";
import FormularioUsuario from "../../components/forms/FormularioUsuario";
import Terms from "../modals/terms";
import Privacy from "../modals/privacy";
import Swal from "sweetalert2";
import { getRolesByCategory } from "../../Functions/papel/get-roles-by-category";
import CpfUtils from "../../shared/utils/CpfUtils";
import RgUtils from "../../shared/utils/RgUtils";
import PhoneUtils from "../../shared/utils/PhoneUtils";
import EmailUtils from "../../shared/utils/EmailUtils";

const Validators = {
  required: v => !!v && !!v.trim(),
  email: v => EmailUtils.validateEmail(v),
  ddd: v => PhoneUtils.cleanPhone(v).length === 2,
  phone: v => {
    const l = PhoneUtils.cleanPhone(v).length;
    return l >= 8 && l <= 9;
  },
  password: v => {
    const minLength = 5;
    return {
      valid:
        v.length >= minLength &&
        !v.includes("%") &&
        /\d/.test(v) &&
        /^\S*$/.test(v),
      errors: {
        hasPercent: v.includes("%"),
        minLength: v.length > 0 && v.length < minLength,
        hasNumber: v.length > 0 && !/\d/.test(v),
        hasWhitespace: v.length > 0 && !/^\S*$/.test(v),
      }
    };
  }
};

class CadastroUsuario extends Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {
      payload: {
        nome: "",
        surname: "",
        email: "",
        email1: "",
        papel: "",
        datanasc: "",
        cpf: "",
        rg: "",
        dddTelefone: "",
        telephone: "",
        dddCelular: "",
        cellphone: "",
        password: "",
        confirmPassword: "",
        terms: false,
        newsletter: false,
      },
      papeis: [],
      errors: {},
      passwordErrors: {},
      passwordInvalid: false,
      senhasNaoConferem: false,
      showTermsModal: false,
      showPrivacyModal: false,
    };

    this.formRef = React.createRef();
    this.telefoneRef = React.createRef();
    this.celularRef = React.createRef();
    this.formularioUsuarioRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.dados) {
      this.setState({
        payload: {
          ...this.state.payload,
          ...this.props.dados,
        },
      });
    }
    this.buscarPapeis();

    // Focar no primeiro campo quando o componente é montado
    setTimeout(() => {
      if (this.formularioUsuarioRef.current && this.formularioUsuarioRef.current.focusFirstField) {
        this.formularioUsuarioRef.current.focusFirstField();
      }
    }, 100);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.perfil !== this.props.perfil) {
      this.buscarPapeis();
    }
    if (prevProps.dados !== this.props.dados) {
      if (this.props.dados) {
        this.setState({
          payload: {
            ...this.state.payload,
            ...this.props.dados,
          },
        });
      } else {
        this.setState({
          payload: {
            nome: "",
            surname: "",
            email: "",
            email1: "",
            papel: "",
            datanasc: "",
            cpf: "",
            rg: "",
            dddTelefone: "",
            telephone: "",
            dddCelular: "",
            cellphone: "",
            password: "",
            confirmPassword: "",
            terms: false,
            newsletter: false,
          },
        });
      }
    }
  }

  focusFirstField = () => {
    if (this.formularioUsuarioRef.current && this.formularioUsuarioRef.current.focusFirstField) {
      this.formularioUsuarioRef.current.focusFirstField();
    }
  }

  async buscarPapeis() {
    try {
      const mapeamentoPerfil = {
        "OTICA": {
          categoria: "OTICA",
          papelExcluir: "Novo Usuário Óptica"
        },
        "OTICA_PRODUTORA": {
          categoria: "OTICA",
          papelExcluir: "Novo Usuário Óptica"
        },
        "LABORATORIO": {
          categoria: "LAB_INDEPENDENTE",
          papelExcluir: "Novo Usuário Lab Independente"
        }
      };

      if (!this.props.perfil) {
        this.setState({ papeis: [] });
        return;
      }

      const config = mapeamentoPerfil[this.props.perfil];
      if (!config) {
        this.setState({ papeis: [] });
        return;
      }

      const { categoria, papelExcluir } = config;

      let papeis = await getRolesByCategory(categoria, 1);

      if (papeis?.status && papeis.status !== "sucesso") {
        console.error("Erro ao buscar papéis da API OEC:", papeis);
        this.setState({ papeis: [] });
        return;
      }

      const opcoesFiltradas = Array.isArray(papeis?.items)
        ? papeis.items
            .filter(item => {
              const temEditadoUsuario = item?.EditadoUsuario === true || item?.EditadoUsuario === "true" || item?.EditadoUsuario === 1;
              const naoEhExcluido = item?.recordName && item.recordName.trim().toLowerCase() !== papelExcluir.trim().toLowerCase();
              return temEditadoUsuario && naoEhExcluido;
            })
            .map(item => ({
              label: item.recordName,
              value: item.recordName,
            }))
        : [];

      if (opcoesFiltradas.length === 0) {
        console.warn(`Nenhum papel encontrado para a categoria "${categoria}" no OEC.`);
      }

      this.setState({ papeis: opcoesFiltradas });
    } catch (error) {
      console.error("Erro ao buscar papeis:", error);
      this.setState({ papeis: [] });
    }
  }

  handleChange = (name, value) => {
    let cleaned = value;

    if (name === "cpf") {
      cleaned = CpfUtils.cleanCpf(value);
    } else if (name === "rg") {
      cleaned = RgUtils.cleanRg(value);
    } else if (name === "email" || name === "email1") {
      cleaned = EmailUtils.formatEmail(value);
    } else if (["dddTelefone", "dddCelular", "telephone", "cellphone"].includes(name)) {
      cleaned = PhoneUtils.cleanPhone(value);
    }

    this.setState(prev => {
      const payload = { ...prev.payload, [name]: cleaned };
      const errors = { ...prev.errors };
      delete errors[name];
      let emailInvalid = prev.emailInvalid || false;

      if (name === "email" && cleaned && !Validators.email(cleaned)) {
        errors.email = "Email inválido";
      } else if (name === "email" && cleaned && Validators.email(cleaned)) {
        if (payload.email1 && payload.email !== payload.email1) {
          errors.email1 = "Os e-mails não conferem";
          emailInvalid = true;
        } else if (payload.email1 && payload.email === payload.email1) {
          delete errors.email1;
          emailInvalid = false;
        }
      }

      if (name === "email1") {
        if (cleaned && payload.email && cleaned !== payload.email) {
          errors.email1 = "Os e-mails não conferem";
          emailInvalid = true;
        } else if (cleaned && payload.email && cleaned === payload.email) {
          delete errors.email1;
          emailInvalid = false;
        } else if (!cleaned && payload.email) {
          delete errors.email1;
        }
      }

      if (name === "password" || name === "confirmPassword") {
        const pwd = Validators.password(payload.password);
        const newState = {
          payload,
          errors,
          passwordErrors: pwd.errors,
          passwordInvalid: payload.password && !pwd.valid,
          senhasNaoConferem:
            payload.password &&
            payload.confirmPassword &&
            payload.password !== payload.confirmPassword,
          emailInvalid,
        };

        if (this.props.onUpdateUsuario) {
          this.props.onUpdateUsuario(payload);
        }

        return newState;
      }

      if (this.props.onUpdateUsuario) {
        this.props.onUpdateUsuario(payload);
      }

      return { payload, errors, emailInvalid };
    });
  };

  handleCheckbox = (e) => {
    const { name, checked } = e.target;

    if (name === "terms" && checked) {
      this.setState({
        showTermsModal: true
      });
      return;
    }

    this.setState(prev => ({
      payload: { ...prev.payload, [name]: checked }
    }), () => {
      if (this.props.onUpdateUsuario) {
        this.props.onUpdateUsuario(this.state.payload);
      }
    });
  };

  handleCloseTermsModal = () => {
    this.setState({
      showTermsModal: false,
      showPrivacyModal: true
    });
  };

  handleClosePrivacyModal = () => {
    this.setState({
      showPrivacyModal: false,
      payload: { ...this.state.payload, terms: true }
    }, () => {
      if (this.props.onUpdateUsuario) {
        this.props.onUpdateUsuario(this.state.payload);
      }
    });
  };

  validateForm = () => {
    const { payload } = this.state;
    const errors = {};

    if (!Validators.required(payload.nome)) errors.nome = "Campo obrigatório";
    if (!Validators.required(payload.surname)) errors.surname = "Campo obrigatório";

    if (!Validators.email(payload.email)) errors.email = "Email inválido";
    if (payload.email !== payload.email1) errors.email1 = "Os e-mails não conferem";

    if (!this.props.referencial && !Validators.required(payload.papel)) errors.papel = "Campo obrigatório";
    if (!Validators.required(payload.datanasc)) errors.datanasc = "Campo obrigatório";
    if (!Validators.required(payload.cpf)) errors.cpf = "Campo obrigatório";
    if (!Validators.required(payload.rg)) errors.rg = "Campo obrigatório";

    if (!Validators.ddd(payload.dddCelular)) errors.dddCelular = "DDD inválido";
    if (!Validators.phone(payload.cellphone)) errors.cellphone = "Celular inválido";

    const pwd = Validators.password(payload.password);
    if (!pwd.valid) errors.password = "Senha inválida";
    if (payload.password !== payload.confirmPassword)
      errors.confirmPassword = "As senhas não conferem";

    if (!payload.terms) {
      Swal.fire({
        text: "Você deve aceitar os Termos de Serviço.",
        icon: "warning",
        confirmButtonColor: "#00518b",
      });
      return false;
    }

    this.setState({
      errors,
      passwordErrors: pwd.errors,
      passwordInvalid: !pwd.valid,
      senhasNaoConferem: payload.password !== payload.confirmPassword,
    });

    return Object.keys(errors).length === 0;
  };

  handleCadastrar = e => {
    e.preventDefault();
    if (this.validateForm()) {
      this.props.cadastrar();
    }
  };

  render() {
    const { onlyS9, referencial } = this.props;
    const errors = {
      ...this.state.errors,
      senhasNaoConferem: this.state.senhasNaoConferem,
    };

    if (this.state.emailInvalid && !errors.email1) {
      errors.email1 = "Os e-mails não conferem";
    }

    return (
      <div className="signup-right__next-account" id="secondForm">
        <form className="signup-right__next-account--form" autoComplete="off" ref={this.formRef} onSubmit={this.handleCadastrar} noValidate>
          <FormularioUsuario
            ref={this.formularioUsuarioRef}
            values={this.state.payload}
            errors={errors}
            papeis={this.state.papeis}
            passwordErrors={this.state.passwordErrors}
            passwordInvalid={this.state.passwordInvalid}
            readOnlyFields={[]}
            onChange={this.handleChange}
            onCheckboxChange={this.handleCheckbox}
            showLabels={true}
            showPasswordFields={true}
            showTermsFields={true}
            showEmailConfirmation={true}
            showPerfil={!referencial}
            onlyS9={onlyS9}
          />
          {this.state.showTermsModal && (
            <>
              <div className="x-overlay is--active" onClick={this.handleCloseTermsModal} style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 99998 }}></div>
              <Terms onClick={this.handleCloseTermsModal} />
            </>
          )}
          {this.state.showPrivacyModal && (
            <>
              <div className="x-overlay is--active" onClick={this.handleClosePrivacyModal} style={{ position: "fixed", top: 0, left: 0, width: "100%", height: "100%", backgroundColor: "rgba(0,0,0,0.5)", zIndex: 99998 }}></div>
              <Privacy onClick={this.handleClosePrivacyModal} />
            </>
          )}
          <div className="text-center">
            <button type="submit" className="signup-right__next-account--button is--blue" disabled={this.state.disabled}>
              Cadastrar
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default CadastroUsuario;
